module.exports = __webpack_public_path__ + "img/torino.0ac668b2.png";